/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Search_Foot_DefaultInputs */

const en_search_foot_default = /** @type {(inputs: Search_Foot_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`getanyapi.com · ${i?.count} endpoints`)
};

const zh_hans1_search_foot_default = /** @type {(inputs: Search_Foot_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`getanyapi.com · ${i?.count} 个接口`)
};

const pt_br2_search_foot_default = /** @type {(inputs: Search_Foot_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`getanyapi.com · ${i?.count} endpoints`)
};

const es_search_foot_default = /** @type {(inputs: Search_Foot_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`getanyapi.com · ${i?.count} endpoints`)
};

const fr_search_foot_default = /** @type {(inputs: Search_Foot_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`getanyapi.com · ${i?.count} endpoints`)
};

const de_search_foot_default = /** @type {(inputs: Search_Foot_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`getanyapi.com · ${i?.count} Endpoints`)
};

const ru_search_foot_default = /** @type {(inputs: Search_Foot_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`getanyapi.com · эндпоинтов: ${i?.count}`)
};

const it_search_foot_default = /** @type {(inputs: Search_Foot_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`getanyapi.com · ${i?.count} endpoint`)
};

/**
* | output |
* | --- |
* | "getanyapi.com · {count} endpoints" |
*
* @param {Search_Foot_DefaultInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_foot_default = /** @type {((inputs: Search_Foot_DefaultInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Foot_DefaultInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_foot_default(inputs)
	if (locale === "pt-BR") return pt_br2_search_foot_default(inputs)
	if (locale === "es") return es_search_foot_default(inputs)
	if (locale === "fr") return fr_search_foot_default(inputs)
	if (locale === "de") return de_search_foot_default(inputs)
	if (locale === "ru") return ru_search_foot_default(inputs)
	if (locale === "it") return it_search_foot_default(inputs)
	return en_search_foot_default(inputs)
});